import React, { useState, useEffect, useRef } from 'react';
import {
    StyleSheet,
    View,
    ScrollView,
    Dimensions,
    SafeAreaView,
    Platform
} from 'react-native';
import { useSelector, useDispatch } from 'react-redux';

import Colors from '../../../constants/Colors';
import DefaultText from '../../../components/DefaultText';
import TouchableItem from '../../../components/TouchableItem';
import NavContainer from '../../../components/NavContainer';

import * as potentialActions from '../../../store/actions/potential';

const UserSalaryVarianceScreen = props => {
    const userHasVarianceData = useSelector(state => state.potential.userHasVariance);
    const [userHasVariance, setUserHasVariance] = useState(userHasVarianceData);

    const dispatch = useDispatch();

    const sView = useRef();

    const selectionHandler = async (answer) => {
        setUserHasVariance(answer);
        dispatch(potentialActions.setUserHasVariance(answer));
        if (userHasVarianceData === '') {
            if (maritalStatus === 'Married') {
                props.navigation.navigate('PartnerIncomeTas');
            } else {
                props.navigation.navigate('OtherIncome');
            }
        }
    };

    useEffect(() => {
        sView.current.scrollToEnd({ animated: true });
    }, [userHasVariance])

    const doneHandler = () => {
        if ( userHasVariance !== '' ) {
            if (maritalStatus === 'Married') {
                props.navigation.navigate('PartnerIncomeTas');
            } else {
                props.navigation.navigate('OtherIncome');
            }
        }
    };

    useEffect(() => {
        props.navigation.setOptions({
            headerLeft: () =>
                null
        });
    });


    return (
        <SafeAreaView style={styles.screen}>
            <ScrollView ref={sView}>
                <View style={styles.questionContainer}>
                    <DefaultText style={styles.questionText}>Did you have large variance in your monthly salaries ?</DefaultText>
                    <View style={styles.answerContainer}>
                        <TouchableItem
                            style={userHasVariance === false ? styles.activeAnswer : styles.passiveAnswer}
                            onSelectItem={selectionHandler.bind(this, false)}>
                            <DefaultText style={userHasVariance === false ? styles.activeAnswerText : styles.passiveAnswerText}
                            >
                                No, my salary was more or less the same over the months
                    </DefaultText>
                        </TouchableItem>
                        <TouchableItem
                            style={userHasVariance === true ? styles.activeAnswer : styles.passiveAnswer}
                            onSelectItem={selectionHandler.bind(this, true)}
                        >
                            <DefaultText
                                style={userHasVariance === true ? styles.activeAnswerText : styles.passiveAnswerText}
                            >
                                Yes, some month were significantly higher than others
                        </DefaultText>
                        </TouchableItem>
                    </View>

                    <NavContainer
                        backShow={true}
                        nextShow={userHasVariance !== ''}
                        nextNav={doneHandler}
                        backNav={() => { props.navigation.goBack() }}
                    />

                </View>
            </ScrollView>
        </SafeAreaView>
    );
};

export const userSalaryVarianceScreenOptions = navigationData => {
    return {
        headerLeft: () =>
            null
    }
};

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        backgroundColor: Colors.backColor,
        padding: 10,
        alignItems: Platform.OS === 'web' ? 'center' : 'stretch',
    },
    questionContainer: {
        padding: 10,
        minHeight: Dimensions.get('window').height * 0.87,
        justifyContent: Platform.OS === 'web' ? 'center' : 'flex-end',
        maxWidth: 600,
        minWidth: (Platform.OS === 'web' && Dimensions.get('window').width > 600) ? 600 : 0,
    },
    dropDownContainer: {
        marginTop: 20
    },
    questionText: {
        fontFamily: 'lato-bold',
        color: Colors.darkBlue,
        fontSize: 20,
        marginBottom: 50,
        paddingHorizontal: 10
    },
    answerContainer: {
        justifyContent: 'space-between',
        padding: 10
    },
    passiveAnswer: {
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: Colors.darkGreen,
        minHeight: 50,
        width: (Platform.OS === 'web' && Dimensions.get('window').width > 600) ? 250 : (Dimensions.get('window').width - 100) / 2,
        alignItems: 'center',
        justifyContent: 'center'
    },
    activeAnswer: {
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: Colors.darkGreen,
        backgroundColor: Colors.buttonGreen,
        minHeight: 50,
        width: (Platform.OS === 'web' && Dimensions.get('window').width > 600) ? 250 : (Dimensions.get('window').width - 100) / 2,
        alignItems: 'center',
        justifyContent: 'center'
    },
    logo: {
        marginBottom: '40%',
        width: 50,
        height: 50
    },
    activeAnswerText: {
        fontFamily: 'lato-bold',
        fontSize: 20,
        color: Colors.darkGreen,
    },
    passiveAnswerText: {
        fontFamily: 'lato-bold',
        fontSize: 16,
        color: Colors.darkGreen,
    },

});

export default UserSalaryVarianceScreen;